// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"537":"65b9a0c7","932":"fcca714c"}[chunkId] + ".chunk.js";
};